import React from 'react';
import './CustomToolBar.css';

export default function CustomToolbar({ label, onNavigate, date, localizer }) {
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 10 }, (_, i) => currentYear - 2 + i);
  const months = localizer?.messages?.months || [
    'Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin',
    'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre',
  ];

  const handleMonthChange = (e) => {
    const newDate = new Date(date);
    newDate.setMonth(parseInt(e.target.value));
    onNavigate('DATE', newDate);
  };

  const handleYearChange = (e) => {
    const newDate = new Date(date);
    newDate.setFullYear(parseInt(e.target.value));
    onNavigate('DATE', newDate);
  };

  return (
    <div className="custom-toolbar">
      <button onClick={() => onNavigate('PREV')}>Avant</button>

      <div className="custom-toolbar-selects">
        <select value={date.getMonth()} onChange={handleMonthChange}>
          {months.map((month, index) => (
            <option key={month} value={index}>{month}</option>
          ))}
        </select>

        <select value={date.getFullYear()} onChange={handleYearChange}>
          {years.map(year => (
            <option key={year} value={year}>{year}</option>
          ))}
        </select>
      </div>

      <button onClick={() => onNavigate('NEXT')}>Suivant</button>
    </div>
  );
}
